import React, { useEffect, useState, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { styled } from '@mui/material/styles';
import {
  AppBar,
  Avatar,
  Divider,
  Box,
  Toolbar,
  IconButton,
  Typography,
  InputBase,
  Badge,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Button,
  Paper,
  Tooltip,
  Stack,
  MenuList,
  TextField,
  Autocomplete,
  useMediaQuery,
  Backdrop,
  CircularProgress,
  Modal,
  Fade,
  Popover,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import NewLogo from '../../assets/images/Layer_1nu.png';
import DarkLogo from '../../assets/images/Drk_lg.png';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsDrawer from '../Drawers/SettingsDrawer';
import LinkDrawer from '../Drawers/LinkDrawer';
import { Auth, Hub } from 'aws-amplify';
import { useSelector, useDispatch } from 'react-redux';
import { logOutStop } from '../../redux/reducers/logout';
import { API, graphqlOperation } from 'aws-amplify';
import { getCompany } from '../../graphql/queries';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import Radio from '@mui/material/Radio';
import { ArrowDownward, ArrowUpward, Close, Delete, Lock, Person, Restore, Search, Sort } from '@mui/icons-material';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';

import { getCognitoUserSessions, switchCompany } from '../../graphql';
import { createUserPreference } from '../../graphql/';
import { settingsClose, settingsOpen, skipNotSave, skipReset, skipSave } from '../../redux/reducers/companySkipSave';
import { skipOpen, skipFalse } from '../../redux/reducers/companySkip';
import { logOut, LogoutStart } from '../../redux/reducers/login';
import GlobalSearch from '../Drawers/GlobalSearch';
import { DoughnutChartComponent } from '../Chart/DoughnutChartComponent';
import { persistor } from '../../redux/store';
import UserInactiveModal from '../modals/UserInactiveModal';
import NavBreadCrumbs from './NavBreadCrumbs';
import { fetchUserPreference, resetUserPreference } from '../../redux/reducers/UserPreference';
import { setCompanyName, setCompanyDetails, fetchCompanyList, setCompanyList } from '../../redux/reducers/CompanySlice';

import { displayQuickLinks, displaySettings, hideQuickLinks, hideSettings } from '../../redux/reducers/sidebar';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ProfileSettings from '../modals/ProfileSettings';
import { AddBox } from '@mui/icons-material';
import CompanySetupSkip from '../modals/CompanySetupSkip';
import { nonGst } from '../../redux/reducers/gstStatus';
import { fetchCompany } from '../../redux/reducers/CompanySlice';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { updateUserDetailsDevice } from '../../redux/reducers/userDetails';
import ConfirmDeleteCompany from '../modals/ConfirmDeleteCompany';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { setResetAllBiz } from '../../redux/reducers/BizViewSlice';
import { GuidedNav } from '../modals/GuidedTourComponent';
import ConfirmationModal from '../modals/ConfirmationModal';
import DeleteFY from '../modals/DeleteFY';
import ChangePasswordModal from '../modals/changePassword/changePassword';
import IdleTimerComponent from './IdleTimerComponent';
import { useThemes } from '../Theme/theme';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { setResetDashboard } from '../../redux/reducers/DashboardSlice';
import { getCompanyCodeTranslationApi } from '../../redux/apis/getCompanyCodeTranslation.api';
import SupportPage from '../../pages/NewFigma/SupportPage';
import moment from 'moment/moment';
import MenuIcon from '@mui/icons-material/Menu';
import { getCookie } from '../../utils/common';
import { fetchUserAttribute, getUserAttributes } from '../../library/shared';
import { useLambdaFunctionUrl } from '../../hooks/useEmailSettingLambda';
import { setCompanyAndFinancialYearSwitchDetails, setCustomModalAction, setModalOpen } from '../../redux/reducers/controllNavigation';
import API_ENDPOINTS from '../../apiEndpoints';

import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
import { useResetBizviewPeriods } from '../../utils/resetCompanyPreference';
import { useBroadcastChannel } from '../../hooks/useBroadcastChannel';
import RestoreTimer from './RestoreTimer';
import { postLogToLambda } from '../../utils/logging';
import NewIdletimerComponent from './NewIdletimerComponent';
import { validateUserSession } from '../../pages/auth/validateUserSession';
import { clearAll } from '../../redux/reducers/inventoryItemSelectionSlice';
import MyPostingDate from '../MyPostingDate/MyPostingDate';

const CustomIconButton = styled(IconButton)`
  & .MuiBadge-root .MuiBadge-badge {
    width: 15px;
    height: 15px;
    font-size: 0.6rem;
    padding: 0px 4px;
  }
`;
const HamburgerWrapper = styled(IconButton)(({ theme }) => ({
  scale: 0.8,
  width: 25,
  // height: 25,
  // padding: 0,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Line = styled('span')(({ theme }) => ({
  backgroundColor: '#8c8c8c',
  position: 'absolute',
  width: '100%',
  height: 2,
  transition: 'transform 0.3s ease, opacity 0.3s ease',
  '&:nth-of-type(1)': {
    top: 0,
    transformOrigin: 'top left',
  },
  '&:nth-of-type(2)': {
    top: 8,
    opacity: 1,
  },
  '&:nth-of-type(3)': {
    top: 16,
    transformOrigin: 'bottom left',
  },
}));
const ListCmpModal = ({ open, setOpen, body }) => {
  return (
    <Modal aria-labelledby="transition-modal-title" aria-describedby="transition-modal-description" open={open} closeAfterTransition>
      <Fade in={open}>
        <Paper
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            // bgcolor: "background.paper",
            transform: 'translate(-50%, -50%)',
            boxShadow: 24,
            outline: 'none',
            minWidth: '30%',
            '@media (min-width:600px)': {
              width: 'auto',
            },
            width: '90%',
            maxHeight: '90vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '2px 15px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#fff',
              }}
            >
              Company Lists
            </Typography>
            <IconButton aria-label="delete" onClick={() => setOpen(false)}>
              <Close sx={{ color: '#fff' }} />
            </IconButton>
          </Box>
          <div style={{}}>{body()}</div>
        </Paper>
      </Fade>
    </Modal>
  );
};
const CompanyList = ({
  setSearchText,
  toggleSortOrder,
  companyList,
  sortOrder,
  handleCompanyDeletion,
  handleCompanyClick,
  searchText,
  setOpenSkipModal,
  openSkipModal,
  getFormattedFinancialYear,
  saveUserPreference,
  FyID,
  handleFyClose,
  setDeleteFYId,
  setDeleteFyModal,
  changedCompanyID,
  setDeleteFYText,
  isBlocked,
  newFYDta,
  companyPreference = [],
  controllModal,
  isLoading = false,
  isSmall
}) => {
  const { theme } = useThemes();
  const navigate = useControlledNavigation();
  const [isRestoring, setIsRestoring] = useState(false);
  const dispatch = useDispatch();

  const saveSkipStatus = useSelector((state) => state.companySipSaveReducer.saveSkipStatus);

  const checkIsFYPending = (FYID) =>
    companyPreference?.some((preference) => preference?.attributetypecd === 'NewFY Creation' && preference?.attributevalue === FYID) ||
    false;

  const fyCompanyPreference = companyPreference?.find(
    (pref) => pref.attributetypecd === 'NewFY Creation' && Number(pref.attributevalue) > 1
  );

  const [fromStr = '', toStr = '', option = '', startStr = ''] = fyCompanyPreference?.additionalvalue?.split('-') ?? [];

  const { callLambdaFunctionUrl, error } = useLambdaFunctionUrl();

  const handleRestoreCompany = async (CompanyID) => {
    try {
      setIsRestoring(true);
      const method = 'POST';
      const payloadData = {
        type: 'restore',
        purpose: 'Company Restore',
        companyid: CompanyID,
      };
      await callLambdaFunctionUrl({
        url: API_ENDPOINTS.REACT_APP_SEND_OTP_URL,
        payload: payloadData,
        method,
        onSuccess: (data) => {
          if (data.message.includes('successfully restored')) {
            showSuccessSnackbar('Company successfully restored');
            dispatch(fetchCompanyList());
          }
        },
        onError: (err) => {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again.';
          showErrorSnackbar(errorMessage);
          console.error('Error during OTP operation:', err);
        },
      });
    } catch (error) {
    } finally {
      setIsRestoring(false);
    }
  };

  function getRestoreLabel(deletionTsSeconds) {
    const now = moment();
    const expiresAt = moment(deletionTsSeconds * 1000);

    const diffDaysF = expiresAt.diff(now, 'days', true);
    const diffHours = expiresAt.diff(now, 'hours');
    const diffMinutes = expiresAt.diff(now, 'minutes');
    const diffSeconds = expiresAt.diff(now, 'seconds');

    if (diffDaysF >= 1) {
      const days = Math.ceil(diffDaysF);
      return `${days} day${days > 1 ? 's' : ''} left to restore`;
    }

    if (diffHours >= 1) {
      return `${diffHours} hour${diffHours > 1 ? 's' : ''} left to restore`;
    }

    if (diffMinutes >= 1) {
      return `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} left to restore`;
    }

    if (diffSeconds >= 0) {
      return `${diffSeconds} second${diffSeconds > 1 ? 's' : ''} left to restore`;
    }

    return '';
  }
  const { financialYear } = useSelector((state) => state.userPrefrenceandReducer);

  const currentFY = financialYear?.startyear === '2036';

  return (
    <div className="custom-scrollbar" style={{ height: '100%', }}>
      <Box
        sx={{
          // position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: 'background.paper',
          padding: '5px',
          height: '10%',
        }}
      >
        <Box sx={{ display: 'flex', pl: {xs:0, sm:1}, gap: '4px', }}>
          <Box
            sx={{
              flex: 0.6,
              alignItems: 'start',
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'row' },
              gap: '4px',
            }}
          >
            <Button
              variant="outlined"
              startIcon={!isSmall ? <AddBox/> : null}
              sx={{
                fontWeight: 'bold',
                boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.2),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                // fontSize: "10px",
                fontSize: { md: '10px', xs: '8px' },
                backgroundColor: `${theme.palette.nav.main}00`,
                width: { xs: '100px', md: 'fit-content' },
                // border: "1px solid"
                // borderRadius: 5,
              }}
              onClick={() => {
                setOpenSkipModal(true);
                handleFyClose();
              }}
            >
              Create company
            </Button>
            <Tooltip title={currentFY ? 'FY creation beyond 2036-37 is not allowed.' : ''}>
              <Box component="span" sx={{ display: 'inline-flex' }}>
                <Button
                  variant="contained"
                  startIcon={!isSmall ? <AddBox /> : null}
                  sx={{
                    fontWeight: 'bold',
                    fontSize: { md: '10px', xs: '8px' },
                    width: { xs: '85px', md: 'fit-content' },
                  }}
                  disabled={currentFY}
                  onClick={() => {
                    if (saveSkipStatus === false) {
                      dispatch(settingsClose());
                      navigate('/companysetup');
                      return;
                    }
                    if (controllModal?.lastAllowedPath !== '/create-new-financial-year' || !isBlocked) {
                      navigate('/create-new-financial-year');
                      handleFyClose();
                    }
                  }}
                >
                  Add New FY
                </Button>
              </Box>
            </Tooltip>
          </Box>
          <Box
            display="flex"
            // alignItems="center"
            justifyContent="space-between"
            sx={{
              flex: 0.4,
              width: '40%',
              maxWidth: 400,
              borderRadius: 2,
            }}
          >
          <TextField
            placeholder="Search"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            sx={{
              flex: 1,

              '& .MuiOutlinedInput-root': {
                height: 28, // 👈 control height here
              },
              '& input::placeholder': {
                fontSize: '12px',
                color: 'rgba(0, 0, 0, 0.4)', // more transparent
                opacity: 1, // required for MUI
              },
              
            }}
          />
            <Tooltip title={`Sort: ${sortOrder === 'asc' ? 'Ascending' : sortOrder === 'desc' ? 'Descending' : 'Disabled'}`} >
              <IconButton onClick={toggleSortOrder} color={sortOrder ? 'primary' : 'default'}>
                {sortOrder === 'asc' ? <ArrowUpward /> : sortOrder === 'desc' ? <ArrowDownward /> : <Sort />}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      <Box
        className="custom-scrollbar"
        sx={{
          width: '100%',
          maxHeight: '40vh',
          overflowY: 'auto',
          pt: { xs: 0, sm: 0 },
          minHeight:'30vh'
        }}
      >
        <FormControl sx={{ width: '100%' }}>
          <RadioGroup>
            {companyList
              ?.filter((e) => e.CompanyShort?.toLowerCase().includes(searchText?.toLowerCase()))
              .sort((a, b) =>
                sortOrder === 'asc'
                  ? a.CompanyShort.localeCompare(b?.CompanyShort)
                  : sortOrder === 'desc'
                    ? b.CompanyShort.localeCompare(a?.CompanyShort)
                    : null
              )
              ?.map((company, companyIndex) => {
                const sortedFinancialYears = [...company.RelatedFinancialYearData].sort(
                  (a, b) => Number(a.startdate) - Number(b.startdate)
                );

                return (
                  <div key={companyIndex}>
                    <Box
                      key={companyIndex}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        transition: 'background-color 0.3s ease-in-out',
                        '&:hover': {
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : '#f5f5f5',
                        },
                        marginTop: { xs: '-10px', sm: '0px' },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <MenuItem
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            padding: 0,
                            margin: 0,
                            alignItems: 'flex-start',
                            '.css-gbttro-MuiFormControlLabel-root': {
                              color: '#000000',
                              ml: 0,
                            },
                            '&:hover': {
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : '#f5f5f5',
                            },
                            opacity: isLoading ? 0.6 : 1,
                            pointerEvents: isLoading ? 'none' : 'auto',
                          }}
                          onClick={(e) => {
                            if (isLoading) return;
                            localStorage.removeItem('selectedTab');
                            localStorage.removeItem('selectedAccount');
                            localStorage.removeItem('ewayListData');
                            if (isBlocked) {
                              dispatch(setModalOpen(true));
                              dispatch(
                                setCompanyAndFinancialYearSwitchDetails({
                                  isPending: true,
                                  targetCompanyId: company?.CompanyID,
                                  targetFinancialYearId: company.RelatedFinancialYearData[0]?.financialyearid,
                                  isCompanySwitch: true,
                                  message: `Successfully switched to ${company?.CompanyShort} for FY ${getFormattedFinancialYear(
                                    company.RelatedFinancialYearData[0]?.startdate,
                                    company.RelatedFinancialYearData[0]?.enddate
                                  )}`,
                                })
                              );
                              return;
                            }
                            if (changedCompanyID !== company?.CompanyID && company?.companydeletiontime === null) {
                              const getFinancialYearIndex = (financialYearData) => {
                                const firstYear = financialYearData?.[0];
                                return firstYear?.stepscompleted?.length === 3 || !firstYear?.stepscompleted ? 0 : 1;
                              };
                              navigate('/');
                              console.log(
                                getFinancialYearIndex(company.RelatedFinancialYearData),
                                'getFinancialYearIndex',
                                company.RelatedFinancialYearData
                              );
                              saveUserPreference(
                                company.RelatedFinancialYearData?.[getFinancialYearIndex(company.RelatedFinancialYearData)]
                                  ?.financialyearid,
                                company?.CompanyID,
                                'company',
                                company.RelatedFinancialYearData?.[getFinancialYearIndex(company.RelatedFinancialYearData)]?.stepscompleted
                              );
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              margin: 0,
                              width:{xs:'200px',sm:'fit-content'},
                              overflow: 'hidden',
                            }}
                            id="outerForLabel"
                          >
                            <FormControlLabel
                              htmlFor="radio"
                              sx={{
                                '.MuiFormControlLabel-label': {
                                  fontSize: '15px',
                                  pointerEvents: company?.companydeletiontime != null || isLoading ? 'none' : 'auto',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                  maxWidth: {xs:'180px', sm:'fit-content'},  
                                },
                                margin: 0,
                                padding: 0,
                                pointerEvents: company?.companydeletiontime != null || isLoading ? 'none' : 'auto',
                                maxWidth: '100%', 
                              }}
                              checked={company?.CompanyID === changedCompanyID}
                              control={
                                <Radio
                                  id="radio"
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      fontSize: '18px',
                                    },
                                  }}
                                />
                              }
                              value={company?.CompanyShort}
                              label={company?.CompanyShort}
                              disabled={company?.companydeletiontime != null || isLoading}
                            />
                          </Box>
                        </MenuItem>
                      </Box>
                      <Stack direction="row" spacing={1} alignItems="center" sx={{ gap: 0.2, px: 1 }}>
                        {company?.companydeletiontime !== null ? (
                          <>
                            <Box
                              sx={{
                                display: 'inline-block',
                                minWidth: { xs: '150px', sm: '200px' },
                                textAlign: 'right',
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: '12px', sm: '15px' },
                                  color: '#8c8c8c',
                                  fontStyle: 'italic',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <RestoreTimer deletionTsSeconds={company.companydeletiontime} companyID={company?.CompanyID} />
                              </Typography>
                            </Box>{' '}
                            <Tooltip title="Click here to restore this company back to active status">
                              <IconButton
                                disableRipple={false}
                                sx={{
                                  width: { xs: '18px', sm: '22px' },
                                  height: { xs: '18px', sm: '22px' },
                                  background: 'transparent',
                                  border: '1px solid ',
                                  borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#FFE6E2' : '',
                                  '.MuiSvgIcon-root': {
                                    color: theme?.palette?.TmId.id.toString().includes('9') ? '' : '#8c8c8c',
                                  },
                                  '&:hover': {
                                    border: '1px solid ',
                                    borderColor: '#ea143a',
                                  },
                                  '&:hover .MuiSvgIcon-root': {
                                    color: '#ea143a',
                                  },
                                }}
                                onClick={(event) => {
                                  localStorage.removeItem('selectedTab');
                                  localStorage.removeItem('selectedAccount');
                                  localStorage.removeItem('ewayListData');
                                  const button = event.currentTarget;
                                  button.disabled = true;
                                  handleRestoreCompany(company?.CompanyID).finally(() => {
                                    button.disabled = false;
                                  });
                                }}
                              >
                                <Restore
                                  sx={{
                                    color: 'white',
                                    fontSize: { xs: '12px', sm: '15px' },
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </>
                        ) : (
                          changedCompanyID !== company?.CompanyID &&
                          company?.RelatedFinancialYearData?.length === 1 && (
                            <Tooltip title="Delete Company">
                              <IconButton
                                disableRipple={false}
                                sx={{
                                  width: { xs: '18px', sm: '22px' },
                                  height: { xs: '18px', sm: '22px' },
                                  background: 'transparent',
                                  border: '1px solid ',
                                  borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#FFE6E2' : '',
                                  '.MuiSvgIcon-root': {
                                    color: theme?.palette?.TmId.id.toString().includes('9') ? '' : '#8c8c8c',
                                  },
                                  '&:hover': {
                                    border: '1px solid ',
                                    borderColor: '#ea143a',
                                  },
                                  '&:hover .MuiSvgIcon-root': {
                                    color: '#ea143a',
                                  },
                                }}
                                onClick={() => handleCompanyDeletion(company)}
                              >
                                <Delete
                                  sx={{
                                    color: 'white',
                                    fontSize: { xs: '12px', sm: '15px' },
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          )
                        )}

                        <Box sx={{ cursor: isLoading ? 'not-allowed' : 'pointer', ml: { xs: 0.5, sm: 1 }, opacity: isLoading ? 0.6 : 1 }}>
                          {company?.isExpanded ? (
                            <ArrowDropDownIcon
                              sx={{ fontSize: { xs: '24px', sm: '32px' }, pointerEvents: isLoading ? 'none' : 'auto' }}
                              onClick={(e) => {
                                if (isLoading) return;
                                e.stopPropagation();
                                handleCompanyClick(company?.CompanyID);
                              }}
                            />
                          ) : (
                            <ArrowRightIcon
                              sx={{ fontSize: { xs: '24px', sm: '32px' }, pointerEvents: isLoading ? 'none' : 'auto' }}
                              onClick={(e) => {
                                if (isLoading) return;
                                e.stopPropagation();
                                handleCompanyClick(company?.CompanyID);
                              }}
                            />
                          )}
                        </Box>
                      </Stack>{' '}
                    </Box>

                    {sortedFinancialYears?.map((financialYear, financialYearIndex) =>
                      company?.isExpanded ? (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '6px 3px',
                              justifyContent: 'space-between',
                              transition: 'background-color 0.3s ease-in-out',
                              '&:hover': {
                                backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : '#f5f5f5',
                              },
                            }}
                          >
                            <MenuItem
                              sx={{
                                marginTop: { xs: '-20px', sm: '0px' },
                                ml: 4,
                                '.css-gbttro-MuiFormControlLabel-root': {
                                  color: '#000000',
                                },
                                '&:hover': {
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : '#f5f5f5',
                                },
                                opacity: isLoading ? 0.6 : 1,
                                pointerEvents: isLoading ? 'none' : 'auto',
                              }}
                              onClick={(e) => {
                                if (isLoading) return;
                                localStorage.removeItem('selectedTab');
                                localStorage.removeItem('selectedAccount');
                                localStorage.removeItem('ewayListData');
                                e.preventDefault();
                                e.stopPropagation();

                                if (Number(financialYear?.financialyearid) === Number(toStr)) {
                                  showWarningSnackbar('Please complete the Financial Year creation before switching.');
                                  if (!isBlocked) {
                                    if (company?.companydeletiontime === null) {
                                      navigate('/');
                                      saveUserPreference(Number(fromStr), company?.CompanyID, 'fy', []);
                                    }
                                  }
                                  return;
                                }

                                if (isBlocked) {
                                  dispatch(setModalOpen(true));
                                  dispatch(
                                    setCompanyAndFinancialYearSwitchDetails({
                                      isPending: true,
                                      targetCompanyId: company?.CompanyID,
                                      targetFinancialYearId: financialYear?.financialyearid,
                                      isFinancialYearSwitch: true,
                                      message: `Successfully switched to ${company?.CompanyShort} for FY ${getFormattedFinancialYear(
                                        financialYear?.startdate,
                                        financialYear?.enddate
                                      )}`,
                                    })
                                  );
                                  return;
                                }
                                if (company?.companydeletiontime === null) {
                                  navigate('/');
                                  saveUserPreference(
                                    financialYear.financialyearid,
                                    company?.CompanyID,
                                    'fy',
                                    financialYear?.stepscompleted
                                  );
                                }
                              }}
                              key={financialYearIndex}
                            >
                              <FormControlLabel
                                htmlFor="radio2"
                                sx={{
                                  '.MuiFormControlLabel-label': {
                                    fontSize: '15px',
                                  },
                                }}
                                checked={Number(financialYear?.financialyearid) === Number(FyID)}
                                disabled={company?.companydeletiontime != null || isLoading}
                                value={financialYear.financialyearid}
                                control={
                                  <Radio
                                    id="radio2"
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: '18px',
                                      },
                                    }}
                                  />
                                }
                                label={getFormattedFinancialYear(financialYear?.startdate, financialYear?.enddate)}
                              />
                            </MenuItem>
                            {Number(financialYear?.financialyearid) !== Number(FyID) && changedCompanyID === company?.CompanyID && (
                              <IconButton
                                disableRipple={false}
                                sx={{
                                  mr: 1,
                                  width: '22px',
                                  height: '22px',
                                  background: 'transparent',
                                  border: '1px solid ',
                                  borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#FFE6E2' : '',
                                  '.MuiSvgIcon-root': {
                                    color: theme?.palette?.TmId.id.toString().includes('9') ? '' : '#8c8c8c',
                                  },
                                  '&:hover': {
                                    border: '1px solid ',
                                    borderColor: '#ea143a',
                                  },
                                  '&:hover .MuiSvgIcon-root': {
                                    color: '#ea143a',
                                  },
                                }}
                                onClick={() => {
                                  if (checkIsFYPending(financialYear?.financialyearid)) {
                                    showErrorSnackbar('Please complete the Financial Year creation before deleting.');
                                    return;
                                  }

                                  setDeleteFyModal(true);
                                  setDeleteFYText(getFormattedFinancialYear(financialYear?.startdate, financialYear?.enddate));
                                  setDeleteFYId(financialYear?.financialyearid);
                                }}
                              >
                                <Delete
                                  sx={{
                                    color: 'white',
                                    fontSize: '15px',
                                  }}
                                />
                              </IconButton>
                            )}
                          </Box>
                        </>
                      ) : null
                    )}
                  </div>
                );
              })}{}
          </RadioGroup>
        </FormControl>
      </Box>

      <Box
        sx={{
          backgroundColor: `${theme.palette.nav.main}00`,
          // position: "sticky",
          bottom: '1px',
          pb: '5px',
          height: '10%',
        }}
      >
        <Paper
          sx={{
            display: 'flex',
            ml: 1,
            boxShadow: 'none',
            justifyContent:'center'
          }}
        >
          <Button
            size="small"
            variant="contained"
            disableElevation
            sx={{
              width: {xs:'80%', sm:'100%'},
              fontSize: '10px',
              // color: "primary.main",
              border: '0.2px solid',
              borderColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'transparent',
                color: 'primary.main',
              },
            }}
            onClick={handleFyClose}
          >
            Cancel
          </Button>
        </Paper>
      </Box>
    </div>
  );
};

function Navbar({ setSidebarOpen, sidebarOpen, matches }) {
  let { theme } = useThemes();
  const dispatch = useDispatch();
  const navigate = useControlledNavigation();
  const routernavigate = useNavigate();

  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const isDrawerOpen = useSelector((state) => state.sidebarReducer?.settings);

  const isQuickDrawerOpen = useSelector((state) => state.sidebarReducer?.QuickLinks);
  const { userPreference, financialYear, listFYData, loading: isUserefLoading } = useSelector((state) => state.userPrefrenceandReducer);

  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const { resetBizviewPeriods } = useResetBizviewPeriods();

  const setIsDrawerOpen = (value) => {
    if (value) {
      dispatch(displaySettings());
    } else {
      dispatch(hideSettings());
    }
  };
  const setLinkDrawer = (value) => {
    if (value) {
      dispatch(displayQuickLinks());
    } else {
      dispatch(hideQuickLinks());
    }
  };
  const [supportOpen, setSupportOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [fyAnchorEl, setFyAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [daysRemaining, setDaysRemaining] = useState(0);

  const [selectedFy, setSelectedFy] = useState('');

  const [FyID, setFyID] = useState('');
  const [selectedFyID, setSelectedFyID] = useState('');

  let selector = useSelector((state) => state.loginActions.loginStatus);
  let isGoogleUserLoginCompleted = useSelector((state) => state.loginActions.isGoogleUserLoginCompleted);

  const { companyList, Loaded: companyLoaded, companyDetails } = useSelector((state) => state?.companyReducer);

  const [iconHover, setIconHover] = useState();
  const [openInactiveModal, setOpenInactiveModal] = useState(false);
  const [changedCompanyID, setChangedCompanyID] = useState('');
  const [openSkipModal, setOpenSkipModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteCompany, setDeleteCompany] = useState({});
  const [deleteFYId, setDeleteFYId] = useState('');
  const [deleteFYText, setDeleteFYText] = useState('');
  const [deleteFyModal, setDeleteFyModal] = useState(false);
  const idleTimerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);
  const [expandedCompanies, setExpandedCompanies] = useState([]);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleCompanyDeletion = (deleteComDetails) => {
    setOpenConfirm(true);
    setDeleteCompany(deleteComDetails);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  function openInactiveModalPopup() {
    setOpenInactiveModal(true);
  }
  function openModalAfterPrompt() {
    setTimeout(openInactiveModalPopup, 1770 * 1000);
  }
  const stayLoggedIn = () => {
    setOpenInactiveModal(false);

    clearTimeout(sessionTimeoutRef.current);
  };
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSignout = async (reason) => {
    postLogToLambda(reason, 'navbar 1');
    childRef.current?.destroyTutorial();

    handleMenuClose();
    clearTimeout(sessionTimeoutRef.current);
    dispatch(LogoutStart());

    // Redirect to signout page instead of handling logout directly
    routernavigate('/signout', { replace: true });
  };
  let [BackDrop, setBackDrop] = useState();
  const IsRemembered = async () => {
    try {
      setBackDrop(true);
      let remeberStatusCookie = JSON.parse(getCookie('rememberMe'));
      let remeberStatusValue = JSON.parse(localStorage.getItem('Remembered'));
      console.log({ remeberStatusCookie, remeberStatusValue });
      if (remeberStatusValue == false && remeberStatusCookie == null) {
        const currentPath = window.location.pathname;
        const authPages = ['/window-closed-session-expired', '/new-login-detected', '/session-expired', '/logout', '/signout', '/login'];

        if (authPages.some((page) => currentPath.includes(page))) {
          console.log('User is on auth page, skipping logout:', currentPath);
          return;
        } else {
          postLogToLambda('rebember me', 'routesmap 2');
          navigate('/window-closed-session-expired');
          console.log('navigated');
        }
      }
    } catch (e) {
      console.log(e, 'error');
    } finally {
      setBackDrop(false);
    }
  };

  const UserPref = async () => {
    try {
      let array = [...userPreference];
      const tutorialData = array
        ?.sort((a, b) => b?.enteredtimestamp - a?.enteredtimestamp)
        ?.find((item) => item?.attributetypecd === 'TutorialStatus');
      if (tutorialData) {
        if (tutorialData.attributevalue === 0) {
          localStorage.setItem('tutorialCompleted', 'false');
          localStorage.setItem('tutorialStep', 0);
          localStorage.setItem('FirstTutorial', localStorage.getItem('FirstTutorial'));
          // return childRef.current?.startGuidedNavigation();
        } else {
          // localStorage.setItem("FirstTutorial", "true");
        }
      }
    } catch (error) {
      console.error('Error fetching user preferences:', error);
    }
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  let userData = useSelector((state) => state.userDetailsReducer?.userDetails);
  const fySettingState = useSelector((state) => state.fySettingsReducer);

  const isFyOpen = Boolean(fyAnchorEl);
  const [listModalState, setListModalState] = useState();
  const handleFyOpen = (event, modal) => {
    if (modal == 'Modal') return setListModalState(true);
    setFyAnchorEl(event.currentTarget);
  };

  const handleFyClose = () => {
    setFyAnchorEl(null);
    setSearchText('');
  };

  useEffect(() => {
    if (userData?.email) {
      if (!userData?.name) {
        setprofileSettingsModal(true);
      }
    }

    return () => {};
  }, [userData]);

  async function listFy() {
    try {
      let FyArr = [];
      let financialYear = '';
      listFYData?.map((ele) => {
        let startDate = new Date(Number(ele.startdate) * 1000).toString().split(' ');
        let endDate = new Date(Number(ele.enddate) * 1000).toString().split(' ');
        let fYear = startDate[1] + ' ' + startDate[3] + ' ' + '-' + ' ' + endDate[1] + ' ' + endDate[3];
        FyArr.push({ option: fYear, value: ele.financialyearid });

        userPreference?.map((item) => {
          if (item.attributetypecd == 'SelectedFinYear') {
            if (ele?.financialyearid == item?.attributevalue) {
              setFyID(ele?.financialyearid);
              setSelectedFyID(ele?.financialyearid);
              financialYear = getFormattedFinancialYear(ele?.startdate, ele?.enddate);
            }
          }
        });
        setSelectedFy(financialYear);
      });
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    const checkSession = () => {
      IsRemembered();
    };

    checkSession();

    document.addEventListener('visibilitychange', checkSession);
    window.addEventListener('focus', checkSession);

    return () => {
      document.removeEventListener('visibilitychange', checkSession);
      window.removeEventListener('focus', checkSession);
    };
  }, []);

  useEffect(() => {
    if (selector && userPreference) {
      UserPref();
      listFy();
    }
  }, [selector, userPreference]);

  const checkUserisAuthentcatedorTerminate = async () => {
    try {
      const session = await Auth.currentSession();
      const attributes = await getUserAttributes();
      if (attributes?.isGoogleUser && !isGoogleUserLoginCompleted) {
        return console.log('Google login not completed yet');
      }
      console.log('User attributes:', attributes);
      const currentvalidSession = await validateUserSession();
      console.log({ currentvalidSession });
      if (!currentvalidSession.isValid) {
        // Check if user is already on auth-related pages
        const currentPath = window.location.pathname;
        const authPages = ['/window-closed-session-expired', '/new-login-detected', '/session-expired', '/logout', '/signout', '/login'];

        if (authPages.some((page) => currentPath.includes(page))) {
          console.log('User is on auth page, skipping logout:', currentPath);
          return;
        }

        postLogToLambda('invalid session in db', 'navbar 1');
        return navigate('/session-expired?1');
      }
    } catch (err) {
      console.log('Session invalid or expired:', err);
      console.log(err.name);
      if (err.name === 'NotAuthorizedException') {
        postLogToLambda('Not Authorized', 'navbar 2');
        return navigate('/session-expired?2');
      }
    }
  };

  useEffect(() => {
    // Check when user comes back online
    const handleOnline = () => {
      checkUserisAuthentcatedorTerminate();
    };
    checkUserisAuthentcatedorTerminate();

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, [isGoogleUserLoginCompleted]);

  useEffect(() => {
    const tutorialStep = localStorage.getItem('tutorialStep');
    if (tutorialStep !== '0') {
      localStorage.setItem('tutorialCompleted', 'false');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('UserNameDisplay', 'false');
  }, []);

  useEffect(() => {
    if (companyLoaded) {
      getCompanyDetails();
    }
    fetchData();
  }, [companyLoaded]);

  const { sendMessage } = useBroadcastChannel('app-events', {});
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const saveUserPreference = async (financialYearID, companyID, actionType, stepscompleted) => {
    if (isLoading) {
      return; // Prevent multiple simultaneous calls
    }
    setIsLoading(true);
    if (saveSkipStatus == false && location.pathname.includes('companysetup')) {
      showWarningSnackbar('Please complete the company setup');
      setIsLoading(false);
      return;
    }
    try {
      const isFinancialYearComplete = !stepscompleted || stepscompleted?.length === 3;

      const switchCompanyResponse = await API.graphql(
        graphqlOperation(switchCompany, {
          companyid: companyID,
          financialyearid: financialYearID,
        })
      );

      if (isFinancialYearComplete) {
        navigate('/', { force: true });
      } else {
        navigate('/create-new-financial-year', { state: { active_step: stepscompleted?.length } });
        showWarningSnackbar('Please complete all required steps for Financial Year setup');
      }

      setChangedCompanyID(companyID);
      setSelectedFyID(financialYearID);
      setFyID(financialYearID);

      const findSwitchedCompany = companyList.find((obj) => obj.CompanyID == companyID);
      const findSwitchedFY = findSwitchedCompany?.RelatedFinancialYearData?.find((obj) => obj.financialyearid == financialYearID);

      if (actionType === 'create') {
        showSuccessSnackbar(
          <Typography variant="body1">
            <Typography component="span" fontWeight="bold">
              Company {findSwitchedCompany?.CompanyShort}
            </Typography>{' '}
            successfully created and switched!`
          </Typography>
        );
      } else if (actionType === 'fy') {
        const message = `Financial Year ${getFormattedFinancialYear(findSwitchedFY?.startdate, findSwitchedFY?.enddate)} for ${
          findSwitchedCompany?.CompanyShort
        } selected successfully!`;
        showSuccessSnackbar(message);
      } else {
        const message = `Successfully switched to ${findSwitchedCompany?.CompanyShort} for FY ${getFormattedFinancialYear(
          findSwitchedFY?.startdate,
          findSwitchedFY?.enddate
        )}`;
        showSuccessSnackbar(message);
      }
      dispatch(resetUserPreference());
      let fetchcompany = dispatch(fetchCompany());
      let userpreferece = dispatch(fetchUserPreference());
      dispatch(setResetDashboard());
      dispatch(clearAll());
      dispatch({ type: 'resetApi' });
      // Reset company preferences for Current Period and Compare Period
      await resetBizviewPeriods();
      dispatch(updateUserDetailsDevice());
      await Promise.all([fetchcompany, userpreferece]);
      handleFyClose();
      sendMessage('onSwitchCompany', 'Company or Financial Year switched!');
    } catch (error) {
      console.log(error);
      showErrorSnackbar('Something went wrong. Please try again.');
      console.error('Error saving user preference:', error);
    } finally {
      setBackDrop(false);
      setIsLoading(false);
    }
  };

  const [searchText, setSearchText] = useState('');
  const [sortOrder, setSortOrder] = useState(null); // null, 'asc', 'desc'

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => {
      if (prevOrder === 'asc') return 'desc';
      if (prevOrder === 'desc') return null;
      return 'asc';
    });
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      className={window.innerWidth > 1530 ? 'ToRight' : ''}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'left',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'left',
        horizontal: 'right',
      }}
      sx={{ top: { xs: '60px', md: '50px' } }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
      <MenuItem
        onClick={() => {
          setprofileSettingsModal(true);
          handleMenuClose();
        }}
      >
        <ListItemIcon>
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText>Profile Settings</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (userData?.isGoogleUser) {
            return showWarningSnackbar(
              'You have signed in using your Google account. Changing the password is not available here. Please manage your password directly through your Google account settings.'
            );
          }
          setpasswordChangeModal(true);
          handleMenuClose();
        }}
      >
        <ListItemIcon>
          <Lock fontSize="small" />
        </ListItemIcon>
        <>
          <ListItemText>Change Password</ListItemText>
        </>
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (controllModal?.isBlocked) {
            navigate('/');
            dispatch(setCustomModalAction({ key: 'modalName', value: 'logout' }));
            dispatch(setCustomModalAction({ key: 'customModalTrigger', value: true }));
            dispatch(
              setCustomModalAction({
                key: 'onLeaveFunction',
                value: () => handleSignout('logout click'),
              })
            );
            return;
          }
          handleSignout('logout click');
        }}
        sx={{display:{xs:'none', sm:'flex'}}}
        >
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <>
          <ListItemText>Sign out</ListItemText>
        </>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{ top: '10px', display: isMobileMenuOpen ? 'block' : 'none' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem sx={{marginLeft:'-10px',borderBottom: '1px solid rgba(0,0,0,0.08)',borderColor: 'divider'}}>
        <IconButton
          content="Link"
          size="medium"
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={() => {
          // navigate("/companysetup");
          }}
          sx={{ ml: '-4px' }}
        >
          <Link
          style={{ color: '#fff', textDecoration: 'none' }}
          // onClick={(e) => {
          // e.preventDefault();
          // navigate('/companysetup');
          // }}
          >
          <DoughnutChartComponent />
          </Link>
        </IconButton>
        <Box sx={{display:'flex', flexDirection:'column'}}>
          <Typography
            sx={{
            color: 'nav.font',
            fontSize: '14px',
            fontWeight: '600',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '90px', // add width constraint so ellipsis works
            cursor: 'default', // optional: shows tooltip without pointer cursor
            }}
          >
            {companyDetails?.relatedcompanydetailsnew?.[0]?.companyshort || ''}
          </Typography>
          <Typography
           variant="inherit"
            sx={{
            fontSize: '8px',
            color: 'nav.font',
            maxWidth: '80px', 
            whiteSpace: 'nowrap', 
            textOverflow: 'ellipsis',
            }}
          >
            {selectedFy}
          </Typography>
        </Box>
         <Divider sx={{}} />
      </MenuItem>

      {/* <MenuItem>
        <CustomIconButton sx={{ marginRight: '5px' }} size="medium" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <MailIcon sx={{ color: '#8c8c8c' }} />
          </Badge>
        </CustomIconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <CustomIconButton size="medium" aria-label="show 17 new notifications" color="inherit" sx={{ marginRight: '5px' }}>
          <Badge badgeContent={17} color="error">
            <NotificationsIcon sx={{ color: '#8c8c8c' }} />
          </Badge>
        </CustomIconButton>
        <p>Notifications</p>
      </MenuItem> */}
      <MenuItem
        onClick={() => {
          setLinkDrawer(true);
          handleMobileMenuClose();
        }}
      >
        <IconButton
          size="medium"
          aria-label="show 4 new mails"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AddCircleIcon sx={{ color: '#8c8c8c' }} />
        </IconButton>
        <p>Quick Links</p>
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          // navigate("/supportpage")
          handleFyOpen(e, 'Modal');
          setMobileMoreAnchorEl(null);
        }}
      >
        <IconButton
          size="medium"
          aria-label="show 4 new mails"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <SwapHorizontalCircleIcon
            sx={{
              transition: 'transform 0.2s ease-in-out',
              transform: iconHover == 'Support' ? 'translateY(-5px)' : 'translateY(0)',
              // fontSize: "26px",
              color: '#8c8c8c',
              // fontSize: { sm: "18px", md: "20px", lg: "25px" },
            }}
          />
        </IconButton>
        <p>Company</p>
      </MenuItem>
      <MenuItem
        onClick={() => {
          // navigate("/supportpage")
          setSupportOpen(true);
        }}
      >
        <IconButton
          size="medium"
          aria-label="show 4 new mails"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <SupportAgentIcon
            sx={{
              transition: 'transform 0.2s ease-in-out',
              transform: iconHover == 'Support' ? 'translateY(-5px)' : 'translateY(0)',
              // fontSize: "26px",
              color: '#8c8c8c',
              fontSize: { sm: '18px', md: '20px', lg: '25px' },
            }}
          />
        </IconButton>
        <p>Support</p>
      </MenuItem>
      {/* <MenuItem
        onClick={() => {
          setIsDrawerOpen(true);
          handleMobileMenuClose();
        }}
      >
        <IconButton
          size="medium"
          aria-label="show 4 new mails"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <SettingsIcon sx={{ color: "#8c8c8c" }} />
        </IconButton>
        <p>Settings</p>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="medium"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <Avatar alt={userData.name} src={userData.picture} sx={{ width: 30, height: 30 }} />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
      <Box sx={{ px: 1, pb: 0.5 }}>
        <Button
          fullWidth
          onClick={() => {
            if (controllModal?.isBlocked) {
              navigate('/');
              dispatch(setCustomModalAction({ key: 'modalName', value: 'logout' }));
              dispatch(setCustomModalAction({ key: 'customModalTrigger', value: true }));
              dispatch(
                setCustomModalAction({
                  key: 'onLeaveFunction',
                  value: () => handleSignout('logout click'),
                })
              );
              return;
            }
            handleSignout('logout click');
          }}
          sx={{
            height: 36,
            borderRadius: 1.5,

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.8,

            textTransform: 'none',
            fontSize: '8px',
            fontWeight: 200,

            color: '#ff1d61cd',

            // 👇 bring back soft button feel
            backgroundColor: 'rgba(255, 255, 255, 0.2)',  // semi-transparent
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)', // for Safari
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',

            transition: 'all 0.2s ease',

            '&:hover': {
              backgroundColor: 'rgba(211,47,47,0.06)',
              borderColor: 'rgba(211,47,47,0.2)',
            },

            '&:active': {
              transform: 'scale(0.97)',
              boxShadow: '0 1px 1px rgba(0,0,0,0.08)',
            },
          }}
        >
          <LogoutIcon sx={{ fontSize: 14 }} />
          Sign out
        </Button>
      </Box>
    </Menu>
  );
  async function getCompanyDetails(vv) {
    dispatch(setCompanyName(companyDetails?.relatedcompanydetailsnew[0]?.companyshort));
    setChangedCompanyID(companyDetails?.companyid);
    if (companyDetails?.relatedcompanydetailsnew?.length > 0) {
      let checkedCompanySetUp =
        companyDetails?.relatedcompanydetailsnew[0].registrationtype !== 1
          ? companyDetails?.relatedcompanyentity[0].gstin === '' || companyDetails.relatedaddressentity[0]?.district == ''
          : companyDetails?.relatedcompanydetailsnew[0].registrationtype === 3
            ? companyDetails?.relatedcompanyentity[0].gstin === '' ||
              companyDetails?.relatedcompanydetailsnew[0].comppercentage === 0 ||
              companyDetails?.relatedcompanydetailsnew[0].comppercentage === null
            : companyDetails.relatedaddressentity[0]?.district == '';
      console.log(
        companyDetails?.relatedcompanydetailsnew[0]?.stepscompleted !== null &&
          companyDetails?.relatedcompanydetailsnew[0]?.stepscompleted?.length === 2,
        'jjjjjjj'
      );
      if (
        companyDetails?.relatedcompanydetailsnew[0]?.stepscompleted !== null &&
        companyDetails?.relatedcompanydetailsnew[0]?.stepscompleted?.length === 2
      ) {
        dispatch(skipSave());
        dispatch(skipFalse());
        dispatch(nonGst());
      } else {
        dispatch(skipNotSave());
        dispatch(nonGst());
        dispatch(skipFalse());
      }
    } else {
      dispatch(skipOpen());
    }
  }

  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const getFormattedFinancialYear = (start, end) => {
    const startDate = new Date(start * 1000);
    const endDate = new Date(end * 1000);

    const startMonth = startDate.toLocaleString('default', { month: 'short' });
    const startYear = startDate.getFullYear();
    const endMonth = endDate.toLocaleString('default', { month: 'short' });
    const endYear = endDate.getFullYear();

    const formattedDate = `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
    return formattedDate;
  };

  const fetchData = async () => {
    try {
      dispatch(fetchCompanyList());
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleCompanyClick = (id) => {
    const updatedUserCompanyDetails = companyList.map((company) => {
      if (company.CompanyID === id) {
        return { ...company, isExpanded: !company?.isExpanded };
      }
      return company;
    });
    dispatch(setCompanyList(updatedUserCompanyDetails));
    // setUserCompanyDetails(updatedUserCompanyDetails);
  };
  const [passwordChangeModal, setpasswordChangeModal] = useState(false);
  const [profileSettingsModal, setprofileSettingsModal] = useState(false);
  const [openAddNewFyModal, setOpenAddNewFyModal] = useState(false);
  const { activeStep, newFYDta = {} } = useSelector((state) => state.newFyStepsReducer);
  const childRef = useRef(null);

  const [swichConfirmModalOpen, setSwichConfirmModalOpen] = useState(false);
  const [newCompanyDetails, setNewCompanyDetails] = useState();

  const handleCreation = (newComDetails, companyName, startYear, endYear) => {
    if (newComDetails) {
      const { companyid, financialyearid } = newComDetails;
      setNewCompanyDetails({
        companyid,
        financialyearid,
        companyName,
        startYear,
        endYear,
      });
      fetchData();
      setSwichConfirmModalOpen(true);
    }
  };

  const controllModal = useSelector((state) => state.controllNavigationSlice);

  const handleConfirmSwitch = async () => {
    const { companyid, financialyearid, companyName } = newCompanyDetails;
    if (controllModal?.isBlocked) {
      dispatch(setCustomModalAction({ key: 'customModalTrigger', value: true }));
      dispatch(setCustomModalAction({ key: 'modalName', value: 'switchCompany' }));
      dispatch(
        setCompanyAndFinancialYearSwitchDetails({
          isPending: true,
          targetCompanyId: companyid,
          targetFinancialYearId: financialyearid,
          isCompanySwitch: true,
          message: (
            <Typography variant="body1">
              <Typography component="span" fontWeight="bold">
                Company {companyName}
              </Typography>{' '}
              successfully created and switched!`
            </Typography>
          ),
        })
      );
      navigate('/?active=Business_Overview');

      setSwichConfirmModalOpen(false);
      return true;
    }

    await saveUserPreference(financialyearid, companyid, 'create');
    setSwichConfirmModalOpen(false);
    dispatch(skipNotSave());
  };

  let isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /iphone|ipod|blackberry|iemobile|opera mini|mobi/.test(userAgent) || (userAgent.includes('android') && userAgent.includes('mobile'))
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Backdrop open={BackDrop} sx={{ zIndex: 999 }}>
        <CircularProgress />
      </Backdrop>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <GuidedNav props={'close'} ref={childRef} />
      <AppBar
        position="absolute"
        style={{
          // backgroundColor: `white`,
          backgroundColor: `${theme.palette.nav.main}00`,
          // backdropFilter: "blur(5px)",
        }}
        sx={{
          // backgroundColor: `${theme.palette.nav.main}00`,
          // backdropFilter: "blur(5px)",
          boxShadow: 'none',
        }}
      >
        <Toolbar>
          {/* <Box
            sx={{
              width: '40px',
              position: 'relative',
              // padding: "8px",
              cursor: 'pointer',
              display: matches ? 'block' : 'none',
            }}
          >
            {matches === true && (
              <HamburgerWrapper onClick={() => setSidebarOpen((prev) => !prev)}>
                <Line
                  theme={theme}
                  style={{
                    transform: sidebarOpen ? 'translateY(-2px) rotate(45deg)' : 'translateY(0) rotate(0)',
                  }}
                />
                <Line
                  theme={theme}
                  style={{
                    opacity: sidebarOpen ? 0 : 1,
                  }}
                />
                <Line
                  theme={theme}
                  style={{
                    transform: sidebarOpen ? 'translateY(-1px) rotate(-45deg)' : 'translateY(0) rotate(0)',
                  }}
                />
              </HamburgerWrapper>
            )}
          </Box> */}
          <img
            className={theme.palette.primary.main}
            src={theme?.palette?.TmId.id.toString().includes('9') ? DarkLogo : NewLogo}
            alt="Logo"
            style={{
              height: '55px',
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate('/');
            }}
          />
          <NavBreadCrumbs setIsDrawerOpen={setIsDrawerOpen} />
          {/* <IconButton size="medium" aria-label="show 4 new mails" color="inherit"
              onClick={() => setSidebarOpen(prev => (!prev))}
              sx={{ display: { xs: 'bolck', sm: 'none' },marginLeft:'10px',color:'#000' }}
          >
              <DehazeIcon sx={{color:'#8c8c8c'}} fontSize='medium' />
          </IconButton> */}

          <Box sx={{ flexGrow: 1 }} />

          {/* <Box></Box> */}

          {/* <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              marginRight: "5px",
              marginLeft: "5px",
            }}
            onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                setSearchValue("");
              }
            }}
          >
            {smallScreen ? (
              <IconButton
                size="medium"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={() => setOpen(true)}
                color="inherit"
                sx={{ pl: 0, pr: 0 }}
              >
                <Search sx={{ color: "#8c8c8c" }} />
              </IconButton>
            ) : (
              <Paper
                id="globalSearch"
                component="div"
                sx={{
                  p: "2px 2px",
                  display: "flex",
                  alignItems: "center",
                  width: { sm: "130px", md: "150px", lg: "230px" },
                  height: "40px",
                  borderRadius: "10px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Full Search"
                  inputProps={{
                    "aria-label": "Search",
                  }}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setOpen(true);
                      dispatch(settingsOpen());
                    }
                  }}
                />
              </Paper>
            )}

            <arch props={searchValue} open={open} setOpen={setOpen} />
          </Box> */}

          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Box sx={{ m: 1 }} className="myPostingDate">
              <MyPostingDate />
            </Box>
            {/* <Divider sx={{ marginLeft: 1 }} orientation="vertical" variant="middle" flexItem /> */}
            <Box
              sx={{
                mr: '5px',
                // background: '#dddfe6',
                display: {
                  xs: 'none',
                  md: 'flex',
                  borderRadius: 35,
                  height: '50px',
                },
                gap: '10px',
                // border:"solid 1px #dddfe6",
              }}
            >
              <IconButton
                content="Link"
                size="medium"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={() => {
                  // navigate("/companysetup");
                }}
                sx={{ ml: '-4px' }}
              >
                <Link
                  style={{ color: '#fff', textDecoration: 'none' }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/companysetup');
                  }}
                >
                  <DoughnutChartComponent />
                </Link>
              </IconButton>

              {selectedFy == '' ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                    maxWidth: '230px',
                  }}
                >
                  <Typography
                    sx={{
                      color: 'nav.font',
                      fontWeight: '600',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      textTransform: 'capitalize',
                    }}
                  >
                    {companyDetails?.getCompany?.relatedcompanydetailsnew?.length !== 0
                      ? companyDetails?.getCompany?.relatedcompanydetailsnew?.[0].companyshort
                      : companyDetails?.getCompany?.relatedcompanyentity?.length !== 0
                        ? companyDetails?.getCompany?.relatedcompanyentity?.[0].legalname
                        : ''}
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '5px',
                    maxWidth: { md: '120px', lg: '230px' },
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontSize: '14px',
                  }}
                >
                  <div className="tooltip">
                    {/* <Typography className="tooltiptext">
                      {companyDetails?.relatedcompanydetailsnew?.[0]?.companyshort !== ''
                        ? companyDetails?.relatedcompanydetailsnew?.[0]?.companyshort
                        : ''}
                    </Typography> */}
                    <Tooltip title={companyDetails?.relatedcompanydetailsnew?.[0]?.companyshort || ''} placement="left" arrow>
                      <Typography
                        sx={{
                          color: 'nav.font',
                          fontSize: '16px',
                          fontWeight: '600',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          maxWidth: '200px', // add width constraint so ellipsis works
                          cursor: 'default', // optional: shows tooltip without pointer cursor
                        }}
                      >
                        {companyDetails?.relatedcompanydetailsnew?.[0]?.companyshort || ''}
                      </Typography>
                    </Tooltip>
                  </div>

                  <Typography
                    sx={{
                      display: { sm: 'none', md: 'flex' },
                      fontSize: { md: '11px' },
                      color: 'nav.font',
                      pr: { md: '8px', lg: '15px' },
                      width: '100%', // Ensure the Typography component has a fixed width
                      whiteSpace: 'nowrap', // Keep text in a single line
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedFy}
                  </Typography>
                </Box>
              )}
            </Box>
            {/* )} */}
            <Tooltip title="Manage Company" arrow>
              <IconButton
                id="fade-button"
                aria-controls={isFyOpen ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={isFyOpen ? 'true' : undefined}
                onClick={handleFyOpen}
                onMouseEnter={() => setIconHover('SwitchComp')}
                onMouseLeave={() => setIconHover('')}
                sx={{
                  transform: 'rotate(90deg)',
                }}
              >
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'fit-content', // shrink-wrap to icon
                    height: 'fit-content',
                  }}
                  className="SwitchComp"
                >
                  <SwapHorizontalCircleIcon
                    variant="outlined"
                    sx={{
                      transition: 'transform 0.2s ease-in-out',
                      transform: iconHover === 'SwitchComp' ? 'translateX(-5px)' : 'translateX(0)',
                      fontSize: { sm: '18px', md: '20px', lg: '25px' },
                      color: '#2e858b',
                      borderRadius: '100%',
                    }}
                  />
                </div>
              </IconButton>
            </Tooltip>

            <Popover
              open={isFyOpen}
              anchorEl={fyAnchorEl}
              onClose={handleFyClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                sx: {
                  boxShadow: `
                      inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                      0 0 0 1px hsla(0, 0%, 0%, 0.05),
                      0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                      0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                      0 3.5px 6px hsla(0, 0%, 0%, 0.09)
                    `,
                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : '', // same conditional color
                  paddingTop: 0,
                  paddingBottom: 0,
                  maxHeight: '60vh',
                },
              }}
              sx={{
                top: { xs: '10px', md: '5px' }, // optional offset
              }}
            >
              {fyAnchorEl && (
                <CompanyList
                  FyID={FyID}
                  changedCompanyID={changedCompanyID}
                  handleFyClose={handleFyClose}
                  setDeleteFYId={setDeleteFYId}
                  setDeleteFyModal={setDeleteFyModal}
                  getFormattedFinancialYear={getFormattedFinancialYear}
                  saveUserPreference={saveUserPreference}
                  setFyID={setFyID}
                  openSkipModal={openSkipModal}
                  setOpenSkipModal={setOpenSkipModal}
                  searchText={searchText}
                  setSelectedFy={setSelectedFy}
                  setChangedCompanyID={setChangedCompanyID}
                  setSelectedFyID={setSelectedFyID}
                  handleCompanyClick={handleCompanyClick}
                  handleCompanyDeletion={handleCompanyDeletion}
                  sortOrder={sortOrder}
                  companyList={companyList}
                  toggleSortOrder={toggleSortOrder}
                  setSearchText={setSearchText}
                  activeStep={activeStep}
                  setDeleteFYText={setDeleteFYText}
                  isBlocked={controllModal?.isBlocked}
                  controllModal={controllModal}
                  newFYDta={newFYDta}
                  companyPreference={companyPreference}
                  isLoading={isLoading}
                />
              )}
            </Popover>
            {listModalState ? (
              <ListCmpModal
                open={listModalState}
                setOpen={setListModalState}
                body={() => (
                  <>
                    <CompanyList
                      FyID={FyID}
                      changedCompanyID={changedCompanyID}
                      handleFyClose={() => setListModalState(false)}
                      setDeleteFYId={setDeleteFYId}
                      setDeleteFyModal={setDeleteFyModal}
                      getFormattedFinancialYear={getFormattedFinancialYear}
                      saveUserPreference={saveUserPreference}
                      setFyID={setFyID}
                      openSkipModal={openSkipModal}
                      setOpenSkipModal={setOpenSkipModal}
                      searchText={searchText}
                      setSelectedFy={setSelectedFy}
                      setChangedCompanyID={setChangedCompanyID}
                      setSelectedFyID={setSelectedFyID}
                      handleCompanyClick={handleCompanyClick}
                      handleCompanyDeletion={handleCompanyDeletion}
                      sortOrder={sortOrder}
                      companyList={companyList}
                      toggleSortOrder={toggleSortOrder}
                      setSearchText={setSearchText}
                      activeStep={activeStep}
                      setDeleteFYText={setDeleteFYText}
                      isBlocked={controllModal?.isBlocked}
                      controllModal={controllModal}
                      newFYDta={newFYDta}
                      companyPreference={companyPreference}
                      isLoading={isLoading}
                      isSmall = {smallScreen}
                    />
                  </>
                )}
              />
            ) : null}
            <Tooltip title="Quick Links" arrow>
              <IconButton
                size="medium"
                aria-label="show 4 new mails"
                color="inherit"
                onClick={() => setLinkDrawer(true)}
                onMouseEnter={() => {
                  setIconHover('AddCircle');
                }}
                onMouseLeave={() => {
                  setIconHover('');
                }}
              >
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'fit-content', // shrink-wrap to icon
                    height: 'fit-content',
                  }}
                  className="quickLink"
                >
                  <AddCircleIcon
                    sx={{
                      transition: 'transform 0.2s ease-in-out',
                      transform: iconHover == 'AddCircle' ? 'translateY(-5px)' : 'translateY(0)',
                      color: '#2104dde4',
                      fontSize: { sm: '18px', md: '20px', lg: '25px' },
                    }}
                  />
                </div>
              </IconButton>
            </Tooltip>
            <Tooltip title="Support Page" arrow>
              <IconButton
                size="medium"
                aria-label="show 4 new mails"
                color="inherit"
                onClick={() => {
                  // navigate("/supportpage")
                  setSupportOpen(true);
                }}
                onMouseEnter={() => {
                  setIconHover('Support');
                }}
                onMouseLeave={() => {
                  setIconHover('');
                }}
              >
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'fit-content', // shrink-wrap to icon
                    height: 'fit-content',
                  }}
                  className="supportPage"
                >
                  <SupportAgentIcon
                    sx={{
                      transition: 'transform 0.2s ease-in-out',
                      transform: iconHover == 'Support' ? 'translateY(-5px)' : 'translateY(0)',
                      // fontSize: "26px",
                      color: '#17a2b8',
                      fontSize: { sm: '18px', md: '20px', lg: '25px' },
                    }}
                  />
                </div>
              </IconButton>
            </Tooltip>
            <LinkDrawer linkDrawer={isQuickDrawerOpen} setLinkDrawer={setLinkDrawer} />
            {/* <Tooltip title="Settings" arrow>
              <IconButton
                className="AppSettings"
                size="medium"
                onMouseEnter={() => {
                  setIconHover("AppSettings");
                }}
                onMouseLeave={() => {
                  setIconHover("");
                }}
                onClick={(event) => {
                  if (event.altKey) {
                    navigate("/defaultformats01");
                  } else {
                    setIsDrawerOpen(true);
                    dispatch(settingsOpen());
                  }
                }}
                // onClick={() => setIsDrawerOpen(true)

                // }
                aria-label="show 4 new mails"
                color="inherit"
              >
                <SettingsIcon
                  sx={{
                    transition: "transform 0.2s ease-in-out",
                    transform:
                      iconHover == "AppSettings"
                        ? "translateY(-5px)"
                        : "translateY(0)",
                    fontSize: { sm: "18px", md: "20px", lg: "25px" },
                    color: "#8c8c8c",
                  }}
                />
              </IconButton>
            </Tooltip>
            <SettingsDrawer open={isDrawerOpen} setOpen={setIsDrawerOpen} /> */}
            {/*

            {/* <CustomIconButton size="medium" aria-label="show 4 new mails" color="inherit">
              <Badge className="MailBox" badgeContent={4} color="error" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <MailIcon
                  sx={{
                    fontSize: { sm: '18px', md: '20px', lg: '25px' },
                    color: '#8c8c8c',
                  }}
                />
              </Badge>
            </CustomIconButton> */}
            {/* <CustomIconButton size="medium" aria-label="show 17 new notifications" color="inherit">
              <Badge className="Notify" badgeContent={17} color="error">
                <NotificationsIcon
                  sx={{
                    fontSize: { sm: '18px', md: '20px', lg: '25px' },
                    color: '#8c8c8c',
                  }}
                />
              </Badge>
            </CustomIconButton> */}

            <Divider sx={{ marginLeft: 2 }} orientation="vertical" variant="middle" flexItem />
            <IconButton
              size="medium"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <Avatar alt={userData.name} src={userData.picture} sx={{ width: 30, height: 30 }} />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }} className="more1">
            <IconButton
              size="medium"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
              sx={{ pl: 0, pr: 0 }}
            >
              <MoreIcon sx={{ color: '#8c8c8c' }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>{renderMobileMenu}</Box>

      {renderMenu}

      <>
        <UserInactiveModal
            open={openInactiveModal}
            setOpen={setOpenInactiveModal}
            logout={handleSignout}
            logedIn={stayLoggedIn}
          />
        <ChangePasswordModal open={passwordChangeModal} onClose={() => setpasswordChangeModal(false)} />
        {profileSettingsModal && <ProfileSettings open={profileSettingsModal} setOpen={setprofileSettingsModal} />}
        {!profileSettingsModal && <CompanySetupSkip />}

        {/* <div idleTimer={idleTimer}></div> */}

        {openSkipModal && (
          <CompanySetupSkip newCompanyCreation={true} setOpenSkipModal={setOpenSkipModal} page={'Navbar'} resFn={handleCreation} />
        )}
        {openConfirm && (
          <ConfirmDeleteCompany
            openConfirm={openConfirm}
            setOpenConfirm={setOpenConfirm}
            companyDetails={deleteCompany}
            type="company"
            title="Delete Company"
            contentText={
              <Typography variant="body1">
                Are you sure you want to delete the company{' '}
                <span
                  style={{
                    fontWeight: 'bold',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : '#000',
                  }}
                >
                  {deleteCompany?.CompanyShort} {''}
                </span>
                ?
              </Typography>
            }
          />
        )}
        {swichConfirmModalOpen && (
          <ConfirmationModal
            open={swichConfirmModalOpen}
            onClose={() => {
              setSwichConfirmModalOpen(false);
            }}
            onConfirm={handleConfirmSwitch}
            title={
              <Typography variant="h1">
                Switch to{' '}
                <Typography component="span" fontWeight="bold">
                  {newCompanyDetails?.companyName}
                </Typography>{' '}
              </Typography>
            }
            message={
              <Typography variant="body1">
                <span
                  style={{
                    fontWeight: 'bold',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : '#000',
                  }}
                >
                  {newCompanyDetails?.companyName}{' '}
                </span>
                accounts for the year{' '}
                <span
                  style={{
                    fontWeight: 'bold',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : '#000',
                  }}
                >
                  {`${newCompanyDetails?.startYear} - ${newCompanyDetails?.endYear}`}
                </span>{' '}
                created. Would you like to log in to it now?
              </Typography>
            }
          />
        )}

        {open && <GlobalSearch props={searchValue} open={open} setOpen={setOpen} />}
      </>

      {deleteFyModal && (
        <ConfirmDeleteCompany
          openConfirm={deleteFyModal}
          setOpenConfirm={setDeleteFyModal}
          companyDetails={deleteCompany}
          deleteFYId={deleteFYId}
          type="financialYear"
          title={`Delete Financial Year (${deleteFYText})`}
          contentText={
            <Typography variant="body1">
              Are you sure you want to delete the Financial Year{' '}
              <span
                style={{
                  fontWeight: 'bold',
                  color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : '#000',
                }}
              >
                {deleteFYText} {''}
              </span>
              ?
            </Typography>
          }
        />
      )}

      {/* <DeleteFY
        open={deleteFyModal}
        setEntryRows={() => { }}
        setOpen={setDeleteFyModal}
        entryRows={[]}
        entryInd={deleteFYId}
      /> */}

      {/* {openAddNewFyModal && (
        <AddNewFYModal
          open={openAddNewFyModal}
          setOpen={setOpenAddNewFyModal}
          options={userCompanyDetails}
          changedCompanyID={changedCompanyID}
        />
      )} */}
      <SupportPage open={supportOpen} setOpen={setSupportOpen} />
      <NewIdletimerComponent handleSignout={() => handleSignout('idletimeout')} stayLoggedIn={() => stayLoggedIn()} />
      {/* <IdleTimerComponent handleSignout={() => handleSignout('idletimeout')} stayLoggedIn={() => stayLoggedIn()} /> */}
    </Box>
  );
}

export default Navbar;
